/**
 * FullPageHeader and BasicPageHeader are deprecated (not updated for Currency).
 * Prefer SimplePageHeader instead.
 * */
export { default as SimplePageHeader } from './simple-page-header/simple-page-header';
